import { render, staticRenderFns } from "./BaseLocationsMenu.vue?vue&type=template&id=7a91c827"
import script from "./BaseLocationsMenu.vue?vue&type=script&lang=js"
export * from "./BaseLocationsMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports